"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedInterval = exports.highlightedIntervalTestIds = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var timeUtils_1 = require("../utils/timeUtils");
var tests_are_demo_1 = require("@famiprog-foundation/tests-are-demo");
var testIds = (0, tests_are_demo_1.createTestids)('HighlightedInterval', {
    interval: ''
});
exports.highlightedIntervalTestIds = testIds;
/**
 * @extends React.Component<HighlightedInterval.propTypes>
 */
var HighlightedInterval = /** @class */ (function (_super) {
    __extends(HighlightedInterval, _super);
    function HighlightedInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HighlightedInterval.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.shouldUpdate ||
            this.props.height !== nextProps.height ||
            this.props.top !== nextProps.top ||
            !(0, timeUtils_1.convertDateToMoment)(this.props.start).isSame((0, timeUtils_1.convertDateToMoment)(nextProps.start).valueOf()) ||
            !(0, timeUtils_1.convertDateToMoment)(this.props.end).isSame((0, timeUtils_1.convertDateToMoment)(nextProps.end))) {
            return true;
        }
        return false;
    };
    /**
     * @returns { object } style
     */
    HighlightedInterval.prototype.getStyle = function () {
        var _a = this.props.calculateHorizontalPosition(this.props.start, this.props.end), left = _a.left, width = _a.width;
        return __assign(__assign({}, this.props.style), { left: left, width: width, top: this.props.top, height: this.props.height, display: left != undefined && width ? 'block' : 'none' });
    };
    /**
     * @returns { string } className
     */
    HighlightedInterval.prototype.getClassName = function () {
        return "rct9k-highlighted-interval ".concat(this.props.className);
    };
    HighlightedInterval.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { "data-testid": 'r9k1_' + testIds.interval + '_' + this.props.id, className: this.getClassName(), style: this.getStyle() }));
    };
    HighlightedInterval.propTypes = {
        /**
         * Start of the highlighted interval, as date (numeric/millis or moment object, cf. `Timeline.props.useMoment`).
         *
         * @type { object | number }
         */
        start: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.number]).isRequired,
        /**
         * End of the highlighted interval, as date (numeric/millis or moment object, cf. `Timeline.props.useMoment`).
         *
         * @type { object | number}
         */
        end: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.number]).isRequired,
        /**
         * Class name used to render the interval.
         *
         * @type { string }
         */
        className: prop_types_1.default.string,
        /**
         * Style used to render the interval.
         *
         * @type { object }
         */
        style: prop_types_1.default.object,
        /**
         * Internal (passed by parent). The height of the highlighted interval.
         *
         * @type { number }
         */
        height: prop_types_1.default.number,
        /**
         * Internal (passed by parent). `HighlightedInterval` uses absolute positioning, thus it needs the `top` property
         * to set the top edge if the element.
         *
         * @type { number }
         */
        top: prop_types_1.default.number,
        /**
         * Internal (passed by parent). `HighlightedInterval` uses this to set data-testid of the underlying element
         *
         * @type { number }
         */
        id: prop_types_1.default.number,
        /**
         * Internal (passed by parent). This function allows the conversion of `start`/`end` (time) properties to pixels.
         *
         * @type { Function }
         */
        calculateHorizontalPosition: prop_types_1.default.func.isRequired,
        /**
         * Internal (passed by parent). If true timeline will try to minimize re-renders (e.g: the displayed timeline interval changes).
         *
         * @type { boolean }
         */
        shouldUpdate: prop_types_1.default.bool
    };
    HighlightedInterval.defaultProps = {
        className: '',
        style: {},
        height: undefined,
        top: undefined,
        id: undefined,
        calculateHorizontalPosition: function () { },
        shouldUpdate: false
    };
    return HighlightedInterval;
}(react_1.default.Component));
exports.HighlightedInterval = HighlightedInterval;
//# sourceMappingURL=HighlightedInterval.js.map